export default {
  scroll: { page: 'Page position', panel: 'List position' },
  pagerAria: 'List pages',
  time: {
    today: 'Today', yesterday: 'Yesterday', tomorrow: 'Tomorrow', now: 'just now',
    todayAt: 'today {{time}}', yesterdayAt: 'yesterday {{time}}', tomorrowAt: 'tomorrow {{time}}',
    inH: 'in {{h}} h', inM: 'in {{m}} min', inHM: 'in {{h}} h {{m}} min',
    msk: 'MSK', hours: '{{count}} h', hoursShort: 'h', minShort: 'min', every: 'every {{h}} h', everyShort: 'every {{h}}',
    onceADay: 'once a day', daily: 'daily', hourly: 'hourly', zone: '{{zone}} time',
  },
  date: { since: 'since {{date}}', sinceApprox: 'since about {{month}}', periodApprox: '{{month}}, approx.', noDate: 'no date' },
  unit: {
    coin_one: '{{count}} coin', coin_other: '{{count}} coins',
    material_one: '{{count}} story', material_other: '{{count}} stories',
    source_one: '{{count}} source', source_other: '{{count}} sources',
    event_one: '{{count}} event', event_other: '{{count}} events',
    transfer_one: '{{count}} transfer', transfer_other: '{{count}} transfers',
    alert_one: '{{count}} alert', alert_other: '{{count}} alerts',
    day_one: '{{count}} day', day_other: '{{count}} days',
    purchase_one: '{{count}} purchase', purchase_other: '{{count}} purchases',
    question_one: '{{count}} question', question_other: '{{count}} questions',
    asset_one: '{{count}} asset', asset_other: '{{count}} assets',
    network_one: '{{count}} network', network_other: '{{count}} networks',
    post_one: '{{count}} post', post_other: '{{count}} posts',
    signal_one: '{{count}} signal', signal_other: '{{count}} signals',
    piece: '{{qty}}',
  },
  action: {
    close: 'Close', cancel: 'Cancel', save: 'Save', retry: 'Retry', open: 'Open', show: 'Show', later: 'Later', done: 'Done',
    back: 'Back', more: 'Details', change: 'Change', delete: 'Delete', all: 'All', allCoins: 'All coins', copy: 'Copy', copied: 'Copied',
    understood: 'Got it', enable: 'Turn on', settings: 'Set up', toTop: 'Back to top', loading: 'Loading…', checking: 'Checking…',
  },
  state: {
    loadFailed: "Couldn't load {{what}}", loadFailedText: 'The rest of the page works. Try again — it usually helps.',
    sheetFailed: "Couldn't load the data. Close the panel and try again.",
    on: 'on', off: 'off', yes: 'yes', no: 'no',
  },
  plan: { free: 'Free', plus: 'Plus', premium: 'Premium' },
  footer: { slogan: 'Less noise. More clarity.' },
  a11y: { close: 'Close', menu: 'All sections', closeMenu: 'Close menu', theme: 'Theme', toDark: 'Dark theme', toLight: 'Light theme', dark: 'Dark', light: 'Light', importance: 'Importance {{n}} of 3' },
};
